import { Box } from '@chakra-ui/react';

import { TextBold } from 'UiKit/typography';
import { studioText } from 'Const/studio/text';

import styles from './style.module.css';

const Head = () => {
  return (
    <Box className={styles['head-studio__container']}>
      <TextBold className={styles['head-studio__title']}>{studioText?.pageTitle}</TextBold>
    </Box>
  );
};

export default Head;
